import { useState, useCallback } from 'react';
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import { SessionWarning } from './SessionWarning';

interface SessionTimeoutProviderProps {
  children: React.ReactNode;
  timeoutMinutes?: number;
  warningMinutes?: number;
}

export function SessionTimeoutProvider({ 
  children, 
  timeoutMinutes = 30,
  warningMinutes = 5,
}: SessionTimeoutProviderProps) {
  const [showWarning, setShowWarning] = useState(false);
  const [warningTime, setWarningTime] = useState(0);

  const handleWarning = useCallback(() => {
    setShowWarning(true);
    setWarningTime(warningMinutes * 60 * 1000); // Convert to milliseconds
  }, [warningMinutes]);

  const handleTimeout = useCallback(() => {
    setShowWarning(false);
  }, []);

  const { resetTimer } = useSessionTimeout({
    timeoutMinutes,
    warningMinutes,
    onWarning: handleWarning,
    onTimeout: handleTimeout,
  });

  const handleExtendSession = useCallback(() => {
    resetTimer();
    setShowWarning(false);
  }, [resetTimer]);

  const handleCloseWarning = useCallback(() => {
    setShowWarning(false);
  }, []);

  return (
    <>
      {children}
      <SessionWarning
        open={showWarning}
        onClose={handleCloseWarning}
        onExtend={handleExtendSession}
        timeRemaining={warningTime}
      />
    </>
  );
}